/** @jsxImportSource @emotion/react */
import React, { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import CodeDetailGrid from 'pages/admin/codemanagement/CodeDetailGrid';
import CodeGroupGrid from 'pages/admin/codemanagement/CodeGroupGrid';
import { CustomInputText, CustomInputWrap, UseToggle } from 'components/inputs/CustomInput';
import {
  InputBox,
  SearchBox,
  SearchBoxRow,
  SearchButtonWrap,
  SearchCols,
  SearchRows,
} from 'components/layouts/SearchBox';
import { ComboBox } from '../../components/selects/ComboBox';
import { Code } from '../../models/common/CommonCode';
import { getCommonCodeNames } from '../../apis/admin/CommonCode';
import { IconButton } from '../../components/buttons/IconSVG';
import { Button } from '@mui/material';
import { ContentSection } from '../../components/layouts/ContentSection';
import { CommonCodeGroup } from 'models/admin/CommonCode';
const CodeManagementPage: React.FC = () => {
  const { t } = useTranslation();

  const [searchDetailCd, setSearchDetailCd] = useState<string>('');
  const [searchParamData, setSearchParamData] = useState<any>(false);
  const [searchState, setSearchState] = useState<any>(false);

  const initSearchParam = {
    cmnGrCd: '',
    cmnGrCdNm: '',
    wktAreaDivsCd: '',
    useYn: 'Y',
    soprAprvYn: 'Y',
  };

  const [searchParam, setSearchParam] = useState<CommonCodeGroup>(initSearchParam);

  const handleOnChange = (name, value) => {
    setSearchParam({ ...searchParam, [name]: value });
  };

  const btnSearch = () => {
    setSearchDetailCd('');
    setSearchParamData(true);
    if (searchState == true) {
      setSearchState(false);
    }
    if (searchState == false) {
      setSearchState(true);
    }
  };

  const listner = useCallback((param: string) => {
    setSearchDetailCd(param);
  }, []);

  const btnReload = () => {
    setSearchParam(initSearchParam);
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      btnSearch();
    }
  };

  return (
    <>
      <SearchBox>
        <SearchBoxRow>
          <InputBox>
            <SearchRows className=".none">
              <SearchCols>
                <label>{t('admin.grid.업무영역', '업무영역')}</label>
                <CustomInputWrap>
                  <CustomInputText
                    name="wktAreaDivsCd"
                    value={searchParam?.wktAreaDivsCd || ''}
                    onChange={(e) => handleOnChange(e.target.name, e.target.value)}
                    onKeyDown={onKeyDown}
                    placeholder={String(
                      t('admin.msg.업무영역을 입력해주세요.', '업무영역을 입력해 주세요.')
                    )}
                  ></CustomInputText>
                </CustomInputWrap>
              </SearchCols>
              <SearchCols>
                <label>{t('admin.grid.그룹코드명', '그룹코드명')}</label>
                <CustomInputWrap>
                  <CustomInputText
                    name="cmnGrCd"
                    value={searchParam?.cmnGrCd || ''}
                    onChange={(e) => handleOnChange(e.target.name, e.target.value)}
                    onKeyDown={onKeyDown}
                    placeholder={String(
                      t('admin.msg.그룹코드명을 입력해주세요.', '그룹코드명을 입력해 주세요.')
                    )}
                  ></CustomInputText>
                </CustomInputWrap>
              </SearchCols>
              {/* <SearchCols>
                <label>{t('com.label.사용여부', '사용여부')}</label>
                <ComboBox
                  placeholder={'전체'}
                  options={code?.ynFlag}
                  defaultValue={''}
                  onChange={handleTextboxUseYn}
                />
              </SearchCols> */}
              <SearchCols>
                <label>{t('admin.label.공통코드/명', '공통코드/명')}</label>
                <CustomInputWrap>
                  <CustomInputText
                    name="cmnGrCdNm"
                    value={searchParam.cmnGrCdNm || ''}
                    onChange={(e) => handleOnChange(e.target.name, e.target.value)}
                    onKeyDown={onKeyDown}
                    placeholder={String(
                      t('admin.msg.공통코드/명을 입력해 주세요.', '공통코드/명을 입력해 주세요.')
                    )}
                  ></CustomInputText>
                </CustomInputWrap>
              </SearchCols>
            </SearchRows>
            <SearchRows className=".none">
              <SearchCols>
                <label>{t('com.label.운영반영여부', '운영반영여부')}</label>
                <UseToggle className="switch">
                  <input
                    type="checkbox"
                    name="soprAprvYn"
                    value={searchParam.soprAprvYn}
                    checked={searchParam.soprAprvYn === 'Y'}
                    onChange={() => {
                      setSearchParam({
                        ...searchParam,
                        soprAprvYn: searchParam.soprAprvYn === 'Y' ? 'N' : 'Y',
                      });
                    }}
                  />
                  <span className="slider"></span>
                  <span
                    className="labels"
                    data-on={t('com.label.반영', '반영')}
                    data-off={t('com.label.미반영', '미반영')}
                  ></span>
                </UseToggle>
              </SearchCols>
              <SearchCols>
                <label>{t('com.label.사용여부', '사용여부')}</label>
                <UseToggle className="switch">
                  <input
                    type="checkbox"
                    name="useYn"
                    value={searchParam.useYn}
                    checked={searchParam.useYn === 'Y'}
                    onChange={() => {
                      setSearchParam({
                        ...searchParam,
                        useYn: searchParam.useYn === 'Y' ? 'N' : 'Y',
                      });
                    }}
                  />
                  <span className="slider"></span>
                  <span
                    className="labels"
                    data-on={t('com.label.사용', '사용')}
                    data-off={t('com.label.미사용', '미사용')}
                  ></span>
                </UseToggle>
              </SearchCols>
              <SearchCols></SearchCols>
            </SearchRows>
          </InputBox>
          <SearchButtonWrap>
            <Button css={IconButton.button} className="reload" disableRipple onClick={btnReload} />
            <Button css={IconButton.button} className="find" disableRipple onClick={btnSearch}>
              {t('com.button.조회', '조회')}
            </Button>
          </SearchButtonWrap>
        </SearchBoxRow>
      </SearchBox>
      <ContentSection>
        <CodeGroupGrid
          searchParam={searchParam}
          editable={true}
          callBack={listner}
          searchParamData={searchParamData}
          searchState={searchState}
        />
      </ContentSection>
      <ContentSection>
        <CodeDetailGrid sCmnGrCd={searchDetailCd} editable={true} />
      </ContentSection>
    </>
  );
};

export default CodeManagementPage;
